module.exports = __webpack_public_path__ + "img/JP.f8dc0f04.svg";